import { UserAttributes } from "./user-attributes";
import { DocumentAttributes } from "./document-attributes";
import { BusinessAccountAttributes } from "./business-account-attributes";
import { BusinessCategoryAttributes } from "./business-category-attributes";
import { CurrencyAttributes } from "./currency-attributes";
import { BankAccountAttributes } from "./bank-account-attributes";

export enum BusinessTypeEnum {
  personal = 1,
  enterprise = 2,
}

export interface BusinessAttributes {
  id?: number;
  is_retailer: number;
  business_type: BusinessTypeEnum;
  business_category_id: number;
  business_currency_id: number;
  company_name: string;
  company_email: string;
  primary_phone_number: string;
  secondary_phone_number?: string;
  start_date: string;
  company_address: string;
  registration_number: string;
  tax_payer_number: string;
  rib_number: string;
  bic_number: string;
  registration_photo: string;
  tax_payer_photo: string;
  id_bank_photo: string;
  company_logo: string;
  activated_at?: string;
  created_at?: string;
  approved_at?: string;
  declined_at?: string;
  requested_more_at?: string;
  message: string;

  universal_discount?: number;
  toll_discount?: number;
  fuel_discount?: number;
  communication_discount?: number;
  withdraw_fees?: number;
  withdraw_commission_percent?: number;

  owner?: UserAttributes;
  business_category?: BusinessCategoryAttributes;
  business_currency?: CurrencyAttributes;
  documents?: Array<DocumentAttributes>;
  accounts?: Array<BusinessAccountAttributes>;
  bank_account?: BankAccountAttributes;
}
